import React from "react";
import { Box, Typography, Skeleton, Divider } from "@mui/material";
import { billCycle, IPaymentSummaryItem } from "../types";
import { SECTION_TITLES } from "../constants";

interface IPurchaseSummarySectionProps {
  paymentSummary: IPaymentSummaryItem[];
  loading: boolean;
  billingCycle: billCycle;
}

export const PurchaseSummarySection = ({
  paymentSummary,
  loading,
  billingCycle,
}: IPurchaseSummarySectionProps) => {
  const isMonthly = billingCycle === "perMonth";

  return (
    <section className="w-full px-4 space-y-2">
      <Typography className="!text-left !w-full !mt-2 !text-sm !font-semibold">
        {SECTION_TITLES.PURCHASE_SUMMARY}
      </Typography>
      {!loading ? (
        <>
          {paymentSummary.map((item, index) => (
            <React.Fragment key={index}>
              <Box className="flex w-full justify-between gap-2 mt-1">
                <Typography
                  className={`!text-left !text-sm ${
                    item.isBold ? "!font-semibold" : ""
                  }`}
                >
                  {item.description}
                </Typography>
                <Typography
                  className={`!text-right  !text-sm ${
                    item.isBold ? "!font-semibold" : ""
                  }`}
                >
                  {isMonthly ? `from ${item.amount}` : item.amount}
                </Typography>
              </Box>

              {index === 0 && <Divider className="w-full" sx={{ borderColor: "taupe.dark", my: 1.5 }} />}
            </React.Fragment>
          ))}
        </>
      ) : (
        <Skeleton animation="wave" height={100} />
      )}
    </section>
  );
};

